// import { Modal, Table } from "react-bootstrap";
// import { formatSalesValue } from "../../utils/formatUtils";
// import { useEffect, useRef, useState } from "react";
// import PrintableInvoice from "./PrintableInvoice";
// import axios from "axios";
// import ExportableInvoice from "./ExportableInvoice";
// import { PDFDownloadLink } from "@react-pdf/renderer";

// const BillDetail = ({ showModal, handleCloseModal, billInfoList, billInfo, selected }) => {
//     const componentRef = useRef();
//     const baseUrl = process.env.REACT_APP_BASE_URL;
//     const token = sessionStorage.getItem('token');
//     const logo = sessionStorage.getItem('selectedLogo');
//     const [logoSrc, setLogoSrc] = useState('/logo.jpg');
//     const [isImageLoaded, setIsImageLoaded] = useState(false);
//     const [imageLoadError, setImageLoadError] = useState(false);

//     useEffect(() => {
//         const fetchImage = async () => {
//             if (!logo) {
//                 setIsImageLoaded(true);
//                 return;
//             }

//             try {
//                 const response = await axios.get(`${baseUrl}/static/uploads/${logo}`, {
//                     responseType: 'blob',
//                     headers: {
//                         Authorization: `Bearer ${token}`
//                     }
//                 });

//                 const reader = new FileReader();
//                 reader.onload = () => {
//                     setLogoSrc(reader.result);
//                     setIsImageLoaded(true);
//                 };
//                 reader.onerror = () => {
//                     console.error("Failed to read logo image");
//                     setImageLoadError(true);
//                     setIsImageLoaded(true);
//                 };
//                 reader.readAsDataURL(response.data);
//             } catch (error) {
//                 console.error("Failed to fetch logo:", error);
//                 setImageLoadError(true);
//                 setIsImageLoaded(true);
//             }
//         };

//         fetchImage();
//     }, [logo, baseUrl, token]);

//     const handlePrint = () => {
//         const printWindow = window.open('', '_blank');
//         printWindow.document.write(`
//             <html>
//                 <head>
//                     <title>Invoice - ${billInfo.bill_no}</title>
//                     <script src="https://cdn.tailwindcss.com"></script>
//                 </head>
//                 <body>
//                     ${componentRef.current.innerHTML}
//                 </body>
//             </html>
//         `);
//         printWindow.document.close();
//         printWindow.focus();
//         setTimeout(() => {
//             printWindow.print();
//             printWindow.close();
//         }, 500);
//     };

//     return (
//         <Modal show={showModal} onHide={handleCloseModal} size="md">
//             <Modal.Header closeButton>
//                 <Modal.Title className="w-100 text-center">
//                     {selected}
//                 </Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 {billInfo && (
//                     <>
//                         <div className="space-y-2 mb-4">
//                             <div className="font-semibold text-center">Invoice</div>
//                             <div className="flex justify-between">
//                                 <span className="font-semibold">Bill No:</span>
//                                 <span>{billInfo.bill_no}</span>
//                             </div>
//                             <div className="flex justify-between">
//                                 <span className="font-semibold">Start Time:</span>
//                                 <span>{billInfo.Start_Time}</span>
//                             </div>
//                             <div className="flex justify-between">
//                                 <span className="font-semibold">End Time:</span>
//                                 <span>{billInfo.End_Time}</span>
//                             </div>
//                             <div className="flex justify-between">
//                                 <span className="font-semibold">Type:</span>
//                                 <span>{billInfo.Type}</span>
//                             </div>
//                             <div className="flex justify-between">
//                                 <span className="font-semibold">Table No:</span>
//                                 <span>{billInfo.Table_No}</span>
//                             </div>
//                             <div className="flex justify-between">
//                                 <span className="font-semibold">Employee:</span>
//                                 <span>{billInfo.employee}</span>
//                             </div>
//                             <div className="flex justify-between">
//                                 <span className="font-semibold">Payment Mode:</span>
//                                 <span>{billInfo.PaymentMode}</span>
//                             </div>
//                             {billInfo.NoOfGuests && (
//                                 <div className="flex justify-between">
//                                     <span className="font-semibold">No. of Guests:</span>
//                                     <span>{billInfo.NoOfGuests}</span>
//                                 </div>
//                             )}
//                         </div>

//                         <Table striped bordered hover responsive className="text-sm">
//                             <thead>
//                                 <tr>
//                                     <th>Item Name</th>
//                                     <th>Rate</th>
//                                     <th>Qty</th>
//                                     <th>Total</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {!billInfoList?.error &&
//                                     billInfoList.map((item, index) => (
//                                         <tr key={index}>
//                                             <td>{item.itemName}</td>
//                                             <td>{formatSalesValue(item.itemrate)}</td>
//                                             <td>{item.Quantity}</td>
//                                             <td>{formatSalesValue(item.total)}</td>
//                                         </tr>
//                                     ))}
//                             </tbody>
//                         </Table>

//                         <div className="text-right mt-4">
//                             <p>Service Charge: {formatSalesValue(billInfo.serviceCharge)}</p>
//                             <p>VAT: {formatSalesValue(billInfo.vat)}</p>
//                             <p className="font-bold">Total: {formatSalesValue(billInfo.total)}</p>
//                             <p className="font-bold">(After Discount)</p>
//                         </div>
//                     </>
//                 )}
//             </Modal.Body>
//             <Modal.Footer>
//                 <button className="btn btn-primary" onClick={handlePrint}>
//                     Print
//                 </button>
//                 <PDFDownloadLink
//                     document={<ExportableInvoice billInfo={billInfo} billInfoList={billInfoList} logoSrc={logoSrc} />}
//                     fileName={`invoice_${billInfo.bill_no}.pdf`}
//                 >
//                     {({ loading }) => (
//                         <button disabled={loading} className="btn btn-primary">
//                             {loading ? "Preparing..." : "Download PDF"}
//                         </button>
//                     )}
//                 </PDFDownloadLink>
//                 <button className="btn btn-secondary" onClick={handleCloseModal}>
//                     Close
//                 </button>

//                 <div
//                     style={{
//                         position: "absolute",
//                         left: "-9999px",
//                         top: "0",
//                         zIndex: "-1",
//                         background: "#fff"
//                     }}
//                 >
//                     <PrintableInvoice
//                         ref={componentRef}
//                         billInfo={billInfo}
//                         billInfoList={billInfoList}
//                         logoSrc={imageLoadError ? '/logo.jpg' : logoSrc}
//                     />
//                 </div>
//             </Modal.Footer>
//         </Modal>
//     );
// };

// export default BillDetail;







import { Modal, Table } from "react-bootstrap";
import { formatSalesValue } from "../../utils/formatUtils";
import React, { useEffect, useRef, useState } from "react";
import PrintableInvoice from "./PrintableInvoice";
import axios from "axios";
import ExportableInvoice from "./ExportableInvoice";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { toast } from "react-toastify";
import { FaTrashAlt } from "react-icons/fa";

const BillDetail = ({ showModal, handleCloseModal, data, selected, billID }) => {
    const componentRef = useRef();
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem("token");
    const logo = sessionStorage.getItem("selectedLogo");
    const [logoSrc, setLogoSrc] = useState("/logo.jpg");
    const [isImageLoaded, setIsImageLoaded] = useState(false);
    const [imageLoadError, setImageLoadError] = useState(false);
    const [billInfo, setBillInfo] = useState({});
    const [billInfoList, setBillInfoList] = useState([]);

    const [openDescriptionIndex, setOpenDescriptionIndex] = useState(null);
    const [descriptions, setDescriptions] = useState({});
    const [showAllDescriptions, setShowAllDescriptions] = useState(false);

    useEffect(() => {
        setBillInfoList(data.details || []);
        setBillInfo(data || []);
    }, [data]);

    useEffect(() => {
        const fetchImage = async () => {
            if (!logo) {
                setIsImageLoaded(true);
                return;
            }
            try {
                const response = await axios.get(`${baseUrl}/static/uploads/${logo}`, {
                    responseType: "blob",
                    headers: { Authorization: `Bearer ${token}` },
                });

                const reader = new FileReader();
                reader.onload = () => {
                    setLogoSrc(reader.result);
                    setIsImageLoaded(true);
                };
                reader.onerror = () => {
                    console.error("Failed to read logo image");
                    setImageLoadError(true);
                    setIsImageLoaded(true);
                };
                reader.readAsDataURL(response.data);
            } catch (error) {
                console.error("Failed to fetch logo:", error);
                setImageLoadError(true);
                setIsImageLoaded(true);
            }
        };

        fetchImage();
    }, [logo, baseUrl, token]);

    const handleBillInfo = async () => {
        try {
            const { data } = await axios.post(`${baseUrl}/billinfo`, {
                bill_no: billInfo.bill_no,
                Date: billInfo.Date,
                Outlet_Name: selected,
                token: token,
            });

            if (data) {
                setBillInfoList(data.details || []);
                setBillInfo(data || []);
            }
        } catch (error) {
            console.log("Bill error", error);
        }
    };

    const handleDescriptionToggle = (index, item) => {
        if (openDescriptionIndex === index) {
            setOpenDescriptionIndex(null);
        } else {
            setOpenDescriptionIndex(index);
            setDescriptions((prev) => ({
                ...prev,
                [index]: item.item_description || "",
            }));
        }
    };

    const handleDescriptionChange = (index, value) => {
        setDescriptions((prev) => ({ ...prev, [index]: value }));
    };

    const handleSaveDescription = async (index, item) => {
        toast.info(
            <div className="p-2">
                <p className="mb-3 text-white">Are you sure you want to save this info for {item.itemName}?</p>
                <div className="flex justify-between gap-2">
                    <button
                        className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
                        onClick={async () => {
                            try {
                                const payload = {
                                    token,
                                    bill_id: billID,
                                    item_name: item.itemName,
                                    details: descriptions[index],
                                };

                                await axios.post(`${baseUrl}/add-item-details`, payload, {
                                    headers: { Authorization: `Bearer ${token}` },
                                });

                                handleBillInfo();
                                setOpenDescriptionIndex(null);
                                toast.success(`Description added for ${item.itemName}`);
                            } catch (error) {
                                console.error("Error saving description:", error);
                                toast.error(error?.data?.message || error?.message || `Error adding description for ${item.itemName}`);
                            }
                        }}
                    >
                        Save
                    </button>
                    <button
                        className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                        onClick={() => toast.dismiss()}
                    >
                        Cancel
                    </button>
                </div>
            </div>,
            {
                autoClose: false,
                closeButton: false,
                toastId: 'save-item-detail'
            }
        );
    };

    const handleCancelDescription = () => {
        setOpenDescriptionIndex(null);
    };

    const handleDeleteDescription = async (item) => {
        toast.info(
            <div className="p-2">
                <p className="mb-3 text-white">Are you sure you want to delete info for {item.itemName}?</p>
                <div className="flex justify-between gap-2">
                    <button
                        className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
                        onClick={async () => {
                            try {
                                await axios.post(`${baseUrl}/delete-item-details`, {
                                    token,
                                    bill_id: billID,
                                    item_name: item.itemName,
                                })

                                toast.success(`Description deleted for ${item.itemName}`);
                                setDescriptions(null);
                                setOpenDescriptionIndex(null);
                                handleBillInfo();
                            } catch (error) {
                                console.error("Error deleting description:", error);
                                toast.error(error?.data?.message || error?.message || `Error deleting description for ${item.itemName}`);
                            }
                        }}
                    >
                        Delete
                    </button>
                    <button
                        className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                        onClick={() => toast.dismiss()}
                    >
                        Cancel
                    </button>
                </div>
            </div>,
            {
                autoClose: false,
                closeButton: false,
                toastId: 'delete-item-detail'
            }
        );
    }

    const handlePrint = () => {
        const printWindow = window.open("", "_blank");
        printWindow.document.write(`
            <html>
                <head>
                    <title>Invoice - ${billInfo.bill_no}</title>
                    <script src="https://cdn.tailwindcss.com"></script>
                </head>
                <body>
                    ${componentRef.current.innerHTML}
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 500);
    };

    return (
        <Modal show={showModal} onHide={() => {
            handleCloseModal();
            setDescriptions([]);
            setOpenDescriptionIndex(null);
            setShowAllDescriptions(false);
        }} size="md">
            <Modal.Header closeButton>
                <Modal.Title className="w-100 text-center">{selected}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {billInfo && (
                    <>
                        <div className="space-y-2 mb-4">
                            <div className="font-semibold text-center">Invoice</div>
                            <div className="flex justify-between">
                                <span className="font-semibold">Bill No:</span>
                                <span>{billInfo.bill_no}</span>
                            </div>
                            <div className="flex justify-between">
                                <span className="font-semibold">Start Time:</span>
                                <span>{billInfo.Start_Time}</span>
                            </div>
                            <div className="flex justify-between">
                                <span className="font-semibold">End Time:</span>
                                <span>{billInfo.End_Time}</span>
                            </div>
                            <div className="flex justify-between">
                                <span className="font-semibold">Type:</span>
                                <span>{billInfo.Type}</span>
                            </div>
                            <div className="flex justify-between">
                                <span className="font-semibold">Table No:</span>
                                <span>{billInfo.Table_No}</span>
                            </div>
                            <div className="flex justify-between">
                                <span className="font-semibold">Employee:</span>
                                <span>{billInfo.employee}</span>
                            </div>
                            <div className="flex justify-between">
                                <span className="font-semibold">Payment Mode:</span>
                                <span>{billInfo.PaymentMode}</span>
                            </div>
                            {billInfo.NoOfGuests && (
                                <div className="flex justify-between">
                                    <span className="font-semibold">No. of Guests:</span>
                                    <span>{billInfo.NoOfGuests}</span>
                                </div>
                            )}
                        </div>

                        <Table striped bordered hover responsive className="text-sm">
                            <thead>
                                <tr>
                                    <th>
                                        Item Name{" "}
                                        <input
                                            type="checkbox"
                                            className="ml-2"
                                            checked={showAllDescriptions}
                                            onChange={(e) => setShowAllDescriptions(e.target.checked)}
                                        />
                                    </th>
                                    <th>Rate</th>
                                    <th>Qty</th>
                                    <th>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {!billInfoList?.error &&
                                    billInfoList.map((item, index) => (
                                        <React.Fragment key={index}>
                                            <tr>
                                                <td
                                                    className={`cursor-pointer ${!showAllDescriptions ? "hover:underline" : ""}`}
                                                    onClick={() =>
                                                        !showAllDescriptions &&
                                                        handleDescriptionToggle(index, item)
                                                    }
                                                >
                                                    {item.itemName}
                                                    {showAllDescriptions && item.item_description && (
                                                        <div className="text-sm text-gray-700 mt-2">
                                                            {item.item_description?.split("\n").map((line, idx) => (
                                                                <p key={idx}>{line}</p>
                                                            ))}
                                                        </div>
                                                    )}
                                                </td>
                                                <td>{formatSalesValue(item.itemrate)}</td>
                                                <td>{item.Quantity}</td>
                                                <td>{formatSalesValue(item.total)}</td>
                                            </tr>

                                            {!showAllDescriptions &&
                                                openDescriptionIndex === index && (
                                                    <tr>
                                                        <td colSpan="4">
                                                            <textarea
                                                                className="form-control mb-2"
                                                                rows={4}
                                                                placeholder="Write description here..."
                                                                value={descriptions[index] || ""}
                                                                onChange={(e) =>
                                                                    handleDescriptionChange(index, e.target.value)
                                                                }
                                                            />
                                                            <div className="flex justify-between items-center">
                                                                <button
                                                                    className="h-8 w-8 p-0 border rounded flex items-center justify-center text-red-600 hover:bg-red-50"
                                                                    onClick={() =>
                                                                        handleDeleteDescription(item)
                                                                    }
                                                                >
                                                                    <FaTrashAlt className="h-4 w-4" />
                                                                </button>

                                                                <div className="flex gap-2">
                                                                    <button
                                                                        className="px-3 py-1 rounded-sm font-medium bg-green-200 text-green-800 hover:bg-green-300 hover:shadow-md text-xs"
                                                                        onClick={() =>
                                                                            handleSaveDescription(index, item)
                                                                        }
                                                                    >
                                                                        Save
                                                                    </button>
                                                                    <button
                                                                        className="px-3 py-2 rounded-sm font-medium bg-red-200 text-red-800 hover:bg-red-300 hover:shadow-md text-xs"
                                                                        onClick={handleCancelDescription}
                                                                    >
                                                                        Cancel
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                        </React.Fragment>
                                    ))}
                            </tbody>
                        </Table>

                        <div className="text-right mt-4">
                            <p>Service Charge: {formatSalesValue(billInfo.serviceCharge)}</p>
                            <p>VAT: {formatSalesValue(billInfo.vat)}</p>
                            <p className="font-bold">Total: {formatSalesValue(billInfo.total)}</p>
                            <p className="font-bold">(After Discount)</p>
                        </div>
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-primary" onClick={handlePrint}>
                    Print
                </button>
                <PDFDownloadLink
                    document={
                        <ExportableInvoice
                            billInfo={billInfo}
                            billInfoList={billInfoList}
                            logoSrc={logoSrc}
                        />
                    }
                    fileName={`invoice_${billInfo.bill_no}.pdf`}
                >
                    {({ loading }) => (
                        <button disabled={loading} className="btn btn-primary">
                            {loading ? "Preparing..." : "Download PDF"}
                        </button>
                    )}
                </PDFDownloadLink>
                <button className="btn btn-secondary" onClick={handleCloseModal}>
                    Close
                </button>

                <div
                    style={{
                        position: "absolute",
                        left: "-9999px",
                        top: "0",
                        zIndex: "-1",
                        background: "#fff",
                    }}
                >
                    <PrintableInvoice
                        ref={componentRef}
                        billInfo={billInfo}
                        billInfoList={billInfoList}
                        logoSrc={imageLoadError ? "/logo.jpg" : logoSrc}
                    />
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default BillDetail;
